// Import all required modules
import Cards from '@bs/components/views/Cards';
import Carousel from '@bs/components/views/Carousel';
import Dropdown from '@bs/components/views/Dropdown';
import Header from '@bs/components/views/Header';
import ImageCaption from '@bs/components/views/ImageCaption';
import InViewport from '@bs/components/views/InViewport';
import SocialShare from '@bs/components/views/SocialShare';
import StatCounter from '@bs/components/views/StatCounter';
import VideoYoutube from '@bs/components/views/VideoYoutube';
import Footer from '@bs/components/views/Footer';
import SolutionsModule from '@bs/components/views/SolutionsModule';
import HeroSlider from '@bs/components/views/HeroSlider';
import ListAndImage from '@bs/components/views/ListAndImage';
import FeaturedContent from '@bs/components/views/FeaturedContent';
import AreasOfImpactTabs from '@bs/components/views/AreasOfImpactTabs';
import TypesenseSearch from '@bs/components/views/TypesenseSearch';
import HeaderNavigation from '@bs/components/views/HeaderNavigation';
import ImpactModule from '@bs/components/views/ImpactModule';
import FloatingNav from '@bs/components/views/FloatingNav';
import BodyVideo from '@bs/components/views/BodyVideo';
import PartnershipCarousel from '@bs/components/views/PartnershipCarousel';
import AreasOfFocus from '@bs/components/views/AreasOfFocus';
import MediaEmbed from '@bs/components/views/MediaEmbed';
import PartnerLogoScroll from '@bs/components/views/PartnerLogoScroll';
import HeadlineAndForm from '@bs/components/views/HeadlineAndForm';
import FullWidthDropdown from '@bs/components/views/FullWidthDropdown';
import ArticleCarousel from '@bs/components/views/ArticleCarousel';
import AnimatedImpactModule from '@bs/components/views/AnimatedImpactModule';
import ImageCaptionCarousel from '@bs/components/views/ImageCaptionCarousel';
import BoardOfTrustees from '@bs/components/views/BoardOfTrustees';
import LeadershipCarousel from '@bs/components/views/LeadershipCarousel';
import VideosAndText from '@bs/components/views/VideosAndText';
import Financials from '@bs/components/views/Financials';
import EmployeeGrid from '@bs/components/views/EmployeeGrid';
import ArticleSidebar from '@bs/components/views/ArticleSidebar';
import ArticleHero from '@bs/components/views/ArticleHero';
import OurSolutionsTabs from '@bs/components/views/OurSolutionsTabs';
import IllustrationHero from '@bs/components/views/IllustrationHero';

// Export reference to all modules in an object
export default {
  Cards,
  Carousel,
  Dropdown,
  Header,
  HeroSlider,
  FeaturedContent,
  ImageCaption,
  InViewport,
  SocialShare,
  StatCounter,
  VideoYoutube,
  Footer,
  SolutionsModule,
  ListAndImage,
  AreasOfImpactTabs,
  TypesenseSearch,
  HeaderNavigation,
  ImpactModule,
  FloatingNav,
  BodyVideo,
  PartnershipCarousel,
  AreasOfFocus,
  MediaEmbed,
  PartnerLogoScroll,
  HeadlineAndForm,
  FullWidthDropdown,
  ArticleCarousel,
  AnimatedImpactModule,
  ImageCaptionCarousel,
  BoardOfTrustees,
  LeadershipCarousel,
  VideosAndText,
  Financials,
  EmployeeGrid,
  ArticleSidebar,
  ArticleHero,
  OurSolutionsTabs,
  IllustrationHero
};
